<app-message-container
  [svgPath]="baseKey + '.icon' | translate"
  [title]="baseKey + '.title' | translate"
  [description]="baseKey + '.description' | translate"
  [buttonText]="baseKey + '.button_text' | translate"
  [routerPath]="baseKey + '.url' | translate"
></app-message-container>

<app-bottom-image></app-bottom-image>
